<template>
    <div>
        <div v-if="!isNaN(getTotalOfSlots())" v-show="showSlotsCounters" class="form-group">
            <label>Total</label>
            <span data-role="slot-total" :data-slot-total="getTotalOfSlots()">{{ getTotalOfSlots() }} slot(s)</span>
        </div>

        <div class="form-group">
            <label for="slot-duration">{{ durationLabel }}</label>
            <input required :disabled="!canEditDuration" id="slot-duration" min="5" step="1" type="number" name="duration" v-model="slotDuration">
        </div>

        <div v-for="(date, dateKey) in dates">
            <hr v-if="dateKey > 0">
            <h3 class="m-0">{{ moment(date).format('DD.MM.YYYY') }}</h3>
            <div v-for="(dayTimeRange, dtrKey) in getDayTimeRangesForDate(date)">
                <div class="row align-items-end">
                    <div class="form-group col-12 col-md-3" data-validation="required">
                        <label :for="`date-${dateKey+dtrKey}`">{{ dateLabel }}</label>
                        <input :id="`date-${dateKey+dtrKey}`" required type="date" v-model="dayTimeRange.day">
                        <input v-for="n in parseInt(dayTimeRange.number)" type="hidden" :name="'day_time_ranges['+dateKey+dtrKey+n+'][day]'" :value="dayTimeRange.day">
                    </div>

                    <div class="form-group col-12 col-md-2" data-validation="required">
                        <label :for="`start-${dateKey+dtrKey}`">{{ startLabel }}</label>
                        <input :id="`start-${dateKey+dtrKey}`" required type="time" v-model="dayTimeRange.start">
                        <input v-for="n in parseInt(dayTimeRange.number)" type="hidden" :name="'day_time_ranges['+dateKey+dtrKey+n+'][start]'" :value="dayTimeRange.start">
                    </div>

                    <div class="form-group col-12 col-md-2" data-validation="required">
                        <label :for="`end-${dateKey+dtrKey}`">{{ endLabel }}</label>
                        <input :id="`end-${dateKey+dtrKey}`" required type="time" v-model="dayTimeRange.end">
                        <input v-for="n in parseInt(dayTimeRange.number)" type="hidden" :name="'day_time_ranges['+dateKey+dtrKey+n+'][end]'" :value="dayTimeRange.end">
                    </div>

                    <div v-if="showSlotsCounters" class="form-group col-12 col-md-2">
                        <span v-if="dayTimeRange.start && dayTimeRange.end" class="font-weight-bold">
                            <label :for="`number-${dateKey+dtrKey}`">{{ numberOfSlotsLabel }}</label>
                            <input :id="`number-${dateKey+dtrKey}`" required type="number" min="1" v-model="dayTimeRange.number">
                        </span>
                    </div>
                    <div v-else class="form-group col-12 col-md-2"></div>

                    <div class="form-group col-12 col-md-3 d-flex justify-content-end">
                        <button v-if="dayTimeRanges.length > 1" type="button" class="btn-medium-grey" @click="deleteDayTimeRange(dayTimeRange)">{{ deleteLabel }}</button>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end">
                <button type="button" class="btn-blue" @click="addDayTimeRange(date)">{{ addLabel }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"

export default {
    name: "DayTimeRangeForm",

    data: () => ({
        dayTimeRanges: [
           { day: moment().format('YYYY-MM-DD'), start: null, end: null, number: 1 }
        ],
        slotDuration: 60,
        moment,
    }),

    props: {
        showSlotsCounters: {
            default: false
        },
        oldDayTimeRanges: {
            default: null
        },
        oldDuration: {
            default: null,
        },
        canEditDuration: {
            default: true,
        },
        durationLabel: {
            default: 'Default duration'
        },
        startLabel: {
            default: 'Start'
        },
        endLabel: {
            default: 'End'
        },
        dateLabel: {
            default: 'Date'
        },
        addLabel: {
            default: 'Add'
        },
        deleteLabel: {
            default: 'Delete'
        },
        numberOfSlotsLabel: {
            default:  'Number of slots'
        }
    },

    created() {
        if (this.oldDayTimeRanges) {
            this.dayTimeRanges = this.initializeDayTimeRanges(this.oldDayTimeRanges)
            if (!this.oldDuration) {
                this.slotDuration = this.findDefaultDuration()
            }
        }
        if (this.oldDuration) {
            this.slotDuration = this.oldDuration
        }
    },

    methods: {
        getDayTimeRangesForDate(date) {
            return this.dayTimeRanges.filter(timeRange => moment(timeRange.day).isSame(moment(date), 'day'))
        },

        findDefaultDuration() {
            const previousTimeRange = this.dayTimeRanges.length > 0 ? this.dayTimeRanges[this.dayTimeRanges.length - 1] : null

            if (previousTimeRange) {
                const date = moment(previousTimeRange.day)
                const start = previousTimeRange.start
                    ? moment(date.format('YYYY-MM-DD') + ' ' + previousTimeRange.start)
                    : null
                const end = previousTimeRange.end
                    ? moment(date.format('YYYY-MM-DD') + ' ' + previousTimeRange.end)
                    : null
                return end.diff(start, 'minute')
            }

            return null
        },

        addDayTimeRange(date = null) {
            const dayTimeRanges = date ? this.getDayTimeRangesForDate(date) : this.dayTimeRanges
            const previousTimeRange = dayTimeRanges.length > 0 ? dayTimeRanges[dayTimeRanges.length - 1] : null

            let nextEnd = null
            if (previousTimeRange) {
                const date = moment(previousTimeRange.day)
                nextEnd = this.slotDuration && previousTimeRange.end
                    ? moment(date.format('YYYY-MM-DD') + ' ' + previousTimeRange.end)
                        .add(this.slotDuration, 'minute')
                        .format('HH:mm')
                    : null
            }

            this.dayTimeRanges.push({
                day: date ? date : (previousTimeRange ? previousTimeRange.day : null),
                start: previousTimeRange ? previousTimeRange.end : null,
                end: nextEnd,
                number: 1
            })
        },

        deleteDayTimeRange(dayTimeRange) {
            if (this.dayTimeRanges.length > 1) {
                const index = this.dayTimeRanges.indexOf(dayTimeRange);
                this.dayTimeRanges.splice(index, 1)
            }
        },

        getTotalOfSlots() {
            let total = 0
            for (const dayTimeRange of this.dayTimeRanges) {
                total += parseInt(dayTimeRange.number)
            }
            return total
        },

        /**
         * Merge the same day time ranges and sort them
         * @param dayTimeRanges {[]}
         * @returns {*[]}
         */
        initializeDayTimeRanges(dayTimeRanges) {
            const result = []
            for (const dayTimeRange of dayTimeRanges) {
                dayTimeRange.number = 1;
                const existing = result.find(dtr =>
                    dayTimeRange.day == dtr.day &&
                    dayTimeRange.start == dtr.start &&
                    dayTimeRange.end == dtr.end);
                if (existing) {
                    existing.number += dayTimeRange.number;
                } else {
                    result.push(dayTimeRange)
                }
            }

            return result.sort((dtrA, dtrB) => {
                const dtrAMoment = moment(dtrA.day)
                const dtrBMoment = moment(dtrB.day)
                if (dtrAMoment.isBefore(dtrBMoment, 'day')) {
                    return -1
                } else {
                    if (dtrAMoment.isSame(dtrBMoment, 'day')) {
                        return dtrA.start < dtrB.start ? -1 : 1;
                    } else {
                        return 1
                    }
                }
            })
        },
    },

    computed: {
        dates() {
            const dates = this.dayTimeRanges.map(timeRange => timeRange.day)
            return [ ...new Set(dates) ]
        }
    }
}
</script>

<style scoped>

</style>
